import { filesApi } from './files';

export const filespresignurlaudio = filesApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreSignedUrlAudio: builder.query({
      query: ({ eventType, audioType, businessId }) => {
        let query = `s3/user/audio?eventType=${eventType}&audioType=${audioType}`;
        if (businessId) {
          query += `&businessId=${businessId}`;
        }
        return query;
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetPreSignedUrlAudioQuery, useGetPreSignedUrlAudioQuery, usePrefetch } = filespresignurlaudio;
